import React, { useState } from "react";
import { useNotification } from "../../context/NotificationContext";
import { UserInfo, getArtistImage } from "../../services/AdminService";
import { IoImageOutline } from "react-icons/io5";

interface ArtistImageFetcherProps {
  usersList: UserInfo[];
  onImageUpdated: () => void;
}

export const ArtistImageFetcher = ({
  usersList,
  onImageUpdated,
}: ArtistImageFetcherProps) => {
  const { showNotification } = useNotification();
  const [selectedImageUserId, setSelectedImageUserId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFetchArtistImage = async () => {
    if (!selectedImageUserId) {
      showNotification("Please select an artist first.");
      return;
    }
    try {
      setLoading(true);
      const url = await getArtistImage(selectedImageUserId);
      showNotification(`Success! Image updated.`);
      setSelectedImageUserId("");
      onImageUpdated();
    } catch (error: any) {
      showNotification(`Failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-section">
      <h3 className="section-header">Fetch Artist Image</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <select
          className="admin-select"
          value={selectedImageUserId}
          onChange={(e) => setSelectedImageUserId(e.target.value)}
        >
          <option value="">Select Artist...</option>
          {usersList.map((user) => (
            <option key={user.userId} value={user.userId}>
              {user.artistName}
            </option>
          ))}
        </select>
        <button
          className="btn-primary btn-full"
          onClick={handleFetchArtistImage}
          disabled={loading}
        >
          {loading ? (
            "Fetching..."
          ) : (
            <>
              <IoImageOutline style={{ marginRight: 8 }} /> Fetch & Update
            </>
          )}
        </button>
      </div>
    </div>
  );
};
